import { customizeToast } from "./Toast";

const STORAGE_KEY = "schilliger:favorites";
const BUTTON_SELECTOR = "[data-favorite-product-id]";

const parseProductId = (value) => {
	const productId = Number.parseInt(String(value || "").trim(), 10);
	return Number.isFinite(productId) && productId > 0 ? productId : null;
};

const readFavorites = () => {
	try {
		const raw = window.localStorage.getItem(STORAGE_KEY);
		if (!raw) return [];

		const favorites = JSON.parse(raw);
		if (!Array.isArray(favorites)) return [];

		return favorites.map(parseProductId).filter(Boolean);
	} catch (error) {
		return [];
	}
};

const writeFavorites = (favorites) => {
	window.localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
	window.dispatchEvent(new CustomEvent("schilliger:favorites-updated", { detail: favorites }));
};

const isFavorite = (productId) => readFavorites().includes(productId);

const updateButtonState = (button, active) => {
	button.classList.toggle("is-active", active);
	button.setAttribute("aria-pressed", active ? "true" : "false");
	button.setAttribute("aria-label", active ? "Retirer des favoris" : "Ajouter aux favoris");
	button.setAttribute("title", active ? "Retirer des favoris" : "Ajouter aux favoris");
	button.dataset.favoriteState = active ? "active" : "inactive";
};

const syncButtons = (scope = document) => {
	scope.querySelectorAll(BUTTON_SELECTOR).forEach((button) => {
		const productId = parseProductId(button.dataset.favoriteProductId);
		if (!productId) return;

		updateButtonState(button, isFavorite(productId));
	});
};

const toggleFavorite = (productId) => {
	const favorites = readFavorites();
	const nextFavorites = favorites.includes(productId) ? favorites.filter((id) => id !== productId) : [...favorites, productId];

	writeFavorites(nextFavorites);
	return nextFavorites.includes(productId);
};

const bindEvents = () => {
	document.addEventListener("click", (event) => {
		const button = event.target.closest(BUTTON_SELECTOR);
		if (!button) return;

		event.preventDefault();

		const productId = parseProductId(button.dataset.favoriteProductId);
		if (!productId) return;

		const active = toggleFavorite(productId);
		syncButtons(document);
		customizeToast(active, "Produit ajoute aux favoris", "Produit retire des favoris");
	});

	window.addEventListener("storage", (event) => {
		if (event.key !== STORAGE_KEY) return;
		syncButtons(document);
	});

	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			mutation.addedNodes.forEach((node) => {
				if (!(node instanceof HTMLElement)) return;
				if (node.matches?.(BUTTON_SELECTOR)) {
					syncButtons(node.parentElement || document);
					return;
				}

				if (node.querySelector?.(BUTTON_SELECTOR)) {
					syncButtons(node);
				}
			});
		});
	});

	observer.observe(document.body, { childList: true, subtree: true });
};

const Favorites = {
	init() {
		syncButtons(document);
		bindEvents();
	},
};

export { Favorites };
